<template>
  <div class="kab-20-welcome">
    <div class="md-layout md-alignment-center-center">
      <div
        class="welcome-container"
        :class="{ 'has-token': hasToken }"
      >
        <div
          v-if="!hasToken"
          class="event-actions"
        >
          <div class="info-icon">
            <div @click="showInfo">
              <md-icon>
                info
              </md-icon> 
            </div>
            <div v-if="info">
              <p>
                You can navigate and watch the full experience at your own pace, come back and enter where you left, browse the studio texts and bios.
                This experience is best viewed on a larger screen. You may use your mouse to move around in the space, or just sit back and watch. Enjoy the Experience!
              </p>
              <p><strong>Note:</strong>Some scenes may be disturbing</p>
            </div>
          </div>
          <join-event-button />
          <kab-trailer />
        </div>
      </div>
    </div>
    <event-stats />
  </div>
</template>

<script>
import EventStats from "@/components/EventStats"
import JoinEventButton from "@/components/JoinEventButton"
import KabTrailer from "@/components/KabTrailer"
import { mapGetters } from 'vuex';
export default {
  name: "Welcome",
  components: {
    EventStats,
    JoinEventButton,
    KabTrailer
  },
  data () {
    return {
      showDialog: true,
      info: false
    }
  },
  computed: {
    ...mapGetters([
      'hasToken'
    ])
  },
  methods: {
    goToLogin() {
      this.$router.push('/login')
    },
    showInfo() {
      this.info = !this.info
    }
  }
};
</script>

<style lang="scss">
.tooltip {
  // ...

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: #423f3f;
      color: $color;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
      max-width: 100px;
    }

    .popover-arrow {
      border-color: $color;
    }
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.kab-20-welcome { 
  width: 100%;
  height: 100vh;
  object-fit: contain;
  opacity: 0.8;
  .map {
    img {
      position: relative;
      top: 20%;
      left: 10%;
    }
  }
  .kabs-gif {
    width: 80%;
    height: 60%;
  }
}

.info-icon {
  .md-icon {
    color: $color-white !important;
    cursor: pointer;
  }
}

.welcome-container {
  width: 900px;
  position: relative;
  margin-top: 44px;
  margin-bottom: 0;
  left: 0;
  overflow-x: hidden;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: $color-white;
  text-align: center;
  h1 {
    font-size: 72px;
    font-weight: bold;
    color: inherit;
    margin-bottom: 5px;
  }
  h2 {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.29;
    letter-spacing: normal;
    color: #a1aeb7;
    margin: 0
  }
  .title {
    font-size: 14px;
    font-weight: normal;
    line-height: 1.71;
    span {
      color: $color-primary;
      cursor: pointer;
    }
  }
  .event-actions {
    margin-top: 40%;
    position: relative;
    top: 50%;
    .join-event-button {
      width: 208px;
      height: 44px;
      margin-left: 0px;
      background-color: $color-primary !important;
      color: $color-white;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 500; 
      text-align: center;
      background-image: linear-gradient(to left, #a30078, #6a0043);
    }

    .share-event-button {
      width: 148px;
      height: 44px;
      margin-left: 15px;
      font-family: Helvetica;
      font-size: 14px;
      font-weight: bold;
      line-height: 1.71; 
      text-align: center;
      color: $color-primary;
      border-radius: 2px;
      border: 1px solid $color-primary;
    }
  }
}

.has-token {
  margin-bottom: 60px;
}

@media only screen and (max-width: 1366px) {
  .welcome-container {
    position: relative;
    margin-top: 20px;
  }
}

@media only screen and (max-width: 600px) {
  .welcome-container {
    width: 390px;
    position: relative;
    top: 50px;
    right: 0;
    h1 {
      font-size: 40px;
      margin-bottom: 5px;
    }
  }
  .kab-20-welcome { 
    .kabs-gif {
      width: 100%;
      height: 50%;
    }
  }
}

@media only screen and (max-width: 400px) {
  .welcome-container {
    width: 280px;
    position: relative;
    top: 100px;
    right: 70px;
    .event-actions {
      .share-event-button {
        width: 208px;
        margin-left: 0
      }
    }
  }
}

@media only screen and (max-width: 375px) {
  .welcome-container {
    width: 280px;
    position: relative;
    top: 40px;
    right: 45px;
  }
}

@media only screen and (max-width: 320px) {
  .welcome-container {
    width: 250px;
    position: relative;
    top: 50px;
    right: 30px;
  }
}

@media only screen and (max-width: 280px) {
  .welcome-container {
    width: 250px;
    position: relative;
    top: 100px;
    right: 10px;
  }
}

@media only screen and (max-width: 852px) and (orientation: landscape) {
  .welcome-container {
    width: 460px;
    position: relative;
    margin-top: -10px;
    .event-actions {
      .share-event-button {
        width: 208px;
        margin-left: 0
      }
    }
  }
}

@media only screen and (max-width: 832px) and (orientation: landscape) {
  .welcome-container {
    right: 260px;
  }
}

@media only screen and (max-width: 736px) and (orientation: landscape) {
  .welcome-container {
    right: 180px;
  }
}

@media only screen and (max-width: 667px) and (orientation: landscape) {
  .welcome-container {
    right: 120px;
  }
}

@media only screen and (max-width: 568px) and (orientation: landscape) {
  .welcome-container {
    right: 20px;
    h1 {
      font-size: 25px;
      margin-bottom: 5px;
    } 
  }
}

@media only screen and (max-width: 1024px) and (orientation: landscape) {
  .welcome-container {
    top: 0px;
    margin-bottom: 100px;
  }
}

</style>
